import { takeLatest, call, put, select } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { adminUsersApi, sendCode } from "../api";
import { showToast } from "../../../../utils/showToast";

export const SET_LOADING = "saga/users/SET_LOADING";
export const SET_UPDATE_LOADING = "saga/users/SET_UPDATE_LOADING";
export const SET_ACTIONS_LOADING = "saga/users/SET_ACTIONS_LOADING";

export const ADD_USER = "saga/users/ADD_USER";
export const ADD_ADMIN_USER = "saga/users/ADD_ADMIN_USER";

export const SET_ADMIN = "saga/users/SET_ADMIN";
export const SET_ADMIN_SUCCESS = "saga/users/SET_ADMIN_SUCCESS";

export const DUPLICATE_USER = "saga/users/DUPLICATE_USER";
export const DUPLICATE_USER_SUCCESS = "saga/users/DUPLICATE_USER_SUCCESS";

export const EDIT_USER = "saga/users/EDIT_USER";
export const EDIT_USER_SUCCESS = "saga/users/EDIT_USER_SUCCESS";

export const DELETE_USER = "saga/users/DELETE_USER";
export const DELETE_USER_SUCCESS = "saga/users/DELETE_USER_SUCCESS";

export const REACTIVATE_USER = "saga/users/REACTIVATE_USER";

export const MIRROR_USER = "saga/users/MIRROR_USER";
export const MIRROR_USER_SUCCESS = "saga/users/MIRROR_USER_SUCCESS";

export const FETCH_SETTINGS = "saga/users/FETCH_SETTINGS";
export const FETCH_SETTINGS_SUCCESS = "saga/users/FETCH_SETTINGS_SUCCESS";

export const FETCH_USERS = "saga/users/FETCH_USERS";
export const FETCH_USERS_SUCCESS = "saga/users/FETCH_USERS_SUCCESS";

export const FETCH_EMAILS = "saga/users/FETCH_EMAILS";
export const FETCH_EMAILS_SUCCESS = "saga/users/FETCH_EMAILS_SUCCESS";

export const FETCH_ACTIONS = "saga/users/FETCH_ACTIONS";
export const FETCH_ACTIONS_SUCCESS = "saga/users/FETCH_ACTIONS_SUCCESS";

export const FETCH_USER_INFO = "saga/users/FETCH_USER_INFO";
export const FETCH_USER_INFO_SUCCESS = "saga/users/FETCH_USER_INFO_SUCCESS";

export const RESET_STATUS = "saga/users/RESET_STATUS";
export const SET_ERROR = "saga/users/SET_ERROR";
export const SET_STATUS = "saga/users/SET_STATUS";

export const TOGGLE_CORPORATE_SUCCESS = "saga/users/TOGGLE_CORPORATE_SUCCESS";

export const ADD_NEW_ROLE = "saga/users/ADD_NEW_ROLE";

const actionCreators = {
  fetchSettings: createAction(FETCH_SETTINGS),
  fetchUsers: createAction(FETCH_USERS),
  fetchActions: createAction(FETCH_ACTIONS),
  fetchUserInfo: createAction(FETCH_USER_INFO),
  createUser: createAction(ADD_USER),
  createAdminUser: createAction(ADD_ADMIN_USER),
  setAdmin: createAction(SET_ADMIN),
  duplicateUser: createAction(DUPLICATE_USER),
  changeUser: createAction(EDIT_USER),
  mirrorUser: createAction(MIRROR_USER),
  deleteUser: createAction(DELETE_USER),
  reactivateUser: createAction(REACTIVATE_USER),
  resetStatus: createAction(RESET_STATUS),
  getEmails: createAction(FETCH_EMAILS)
};

export const {
  fetchSettings,
  fetchUsers,
  fetchActions,
  fetchUserInfo,
  createUser,
  createAdminUser,
  duplicateUser,
  changeUser,
  mirrorUser,
  deleteUser,
  reactivateUser,
  resetStatus,
  getEmails,
  setAdmin
} = actionCreators;

export default function* watchUsers() {
  yield takeLatestSafe(FETCH_SETTINGS, getSettings);
  yield takeLatestSafe(FETCH_USERS, getUsers);
  yield takeLatestSafe(FETCH_ACTIONS, getActions);
  yield takeLatestSafe(ADD_USER, addUser);
  yield takeLatestSafe(ADD_ADMIN_USER, addAdminUser);
  yield takeLatestSafe(DUPLICATE_USER, copyUser);
  yield takeLatestSafe(MIRROR_USER, mirrorUserPermissions);
  yield takeLatestSafe(DELETE_USER, removeUser);
  yield takeLatestSafe(REACTIVATE_USER, activateUser);
  yield takeLatestSafe(EDIT_USER, editUser);
  yield takeLatestSafe(FETCH_USER_INFO, getUserInfo);
  yield takeLatestSafe(FETCH_EMAILS, fetchEmails);
  yield takeLatestSafe(SET_ADMIN, makeUserAdmin);
}

function takeLatestSafe(action, effect) {
  return takeLatest(action, tryCatch(effect));
}

function tryCatch(effect) {
  return function* (args) {
    try {
      yield call(effect, args);
    } catch (err) {
      console.error(err);
      if (err.response.status === 422) {
        yield put({ type: SET_ERROR, payload: err.response.data });
      }
    }
  };
}

function* getSettings() {
  yield put({ type: SET_LOADING, payload: true });

  const { data } = yield call(adminUsersApi.getSettings);

  yield put({
    type: FETCH_SETTINGS_SUCCESS,
    payload: data
  });

  yield put({ type: SET_LOADING, payload: false });
  // yield getUsers({ payload: { key: "user_type", data: "all_active" } });
}

function* getUsers({ payload: { key, data } }) {
  yield put({ type: SET_UPDATE_LOADING, payload: true });

  let params = {};

  if (key === "multiple") {
    for (let param in data) {
      if (param === "organization_ids") {
        params.organization_ids = data.organization_ids.length
          ? data.organization_ids.map((org) => org.id)
          : undefined;
      } else {
        params[param] = data[param] ? data[param].id.toString() : undefined;
      }
    }
  }

  const searchParam =
    key == "multiple"
      ? params
      : {
          [key]: data.id ? data.id : typeof data == "string" ? data : data.map((d) => d.id)
        };

  const res = yield call(adminUsersApi.getUsers, searchParam);
  yield put({
    type: FETCH_USERS_SUCCESS,
    payload: { users: res.data, searchParam }
  });

  yield put({ type: SET_UPDATE_LOADING, payload: false });
}

function* getActions({ payload }) {
  yield put({ type: SET_ACTIONS_LOADING, payload: true });

  const { data } = yield call(adminUsersApi.getActions, { params: { id: payload } });

  yield put({
    type: FETCH_ACTIONS_SUCCESS,
    payload: data
  });

  yield put({ type: SET_ACTIONS_LOADING, payload: false });
}

function* getUserInfo({ payload }) {
  const { data } = yield call(adminUsersApi.getUserInfo, {
    params: { id: payload }
  });
  yield put({
    type: FETCH_USER_INFO_SUCCESS,
    payload: data
  });
}

function* addUser({ payload: data }) {
  yield put({ type: SET_STATUS, payload: "pending" });

  let user = {
    ...data,
    organization_id: data.organization_id.id.toString(),
    role_id: data.role_id.id.toString(),
    phone_number: data.phone_number ? data.phone_number : undefined
  };

  yield call(adminUsersApi.addUser, { user });

  yield refetchUsers();

  yield put({ type: SET_STATUS, payload: "success" });
}

function* addAdminUser({ payload: { data, type } }) {
  yield put({ type: SET_STATUS, payload: "pending" });
  let { verification_code, ...rest } = data;

  let user = {
    ...rest,
    phone_number: rest.phone_number ? rest.phone_number : undefined
  };

  if (type == "confirm") {
    yield call(adminUsersApi.confirm, { user });
    yield put({ type: RESET_STATUS });

    yield call(sendCode, "sms");
  } else {
    yield call(adminUsersApi.addAdminUser, {
      verification_code: verification_code.toString(),
      user
    });

    yield refetchUsers();
  }
  yield put({ type: SET_STATUS, payload: "success" });
}

function* refetchUsers() {
  // TODO: rework adding user to store instead of repeating search request after adding new user
  const currentSearchParam = yield select((state) => state.users.currentSearchParam);
  if (currentSearchParam) {
    const res = yield call(adminUsersApi.getUsers, {
      ...currentSearchParam
    });

    yield put({
      type: FETCH_USERS_SUCCESS,
      payload: { users: res.data }
    });
  }
}

function* makeUserAdmin({ payload: { data, id, orgName } }) {
  yield put({ type: SET_STATUS, payload: "pending" });

  let res = yield call(adminUsersApi.setAdmin, {
    verification_code: data.verification_code.toString(),
    id: id.toString()
  });

  yield put({
    type: SET_ADMIN_SUCCESS,
    payload: { data: res.data, orgName: orgName, id }
  });

  yield put({ type: SET_STATUS, payload: "success" });
}

function* copyUser({ payload }) {
  yield put({ type: SET_STATUS, payload: "pending" });

  let res = yield call(adminUsersApi.duplicateUser, {
    source_user_id: payload.id.toString(),
    user: payload.data
  });

  yield put({
    type: DUPLICATE_USER_SUCCESS,
    payload: { data: res.data, orgName: payload.orgName }
  });

  yield put({ type: SET_STATUS, payload: "success" });
}

function* mirrorUserPermissions({ payload }) {
  try {
    let res = yield call(adminUsersApi.mirrorUser, {
      source_user_id: payload.id.toString(),
      user: { id: payload.data.map((user) => user.id) }
    });

    if (res.data.users) {
      yield put({
        type: MIRROR_USER_SUCCESS,
        payload: { data: res.data.users, orgName: payload.orgName }
      });
    }

    if (res.status == 200) {
      showToast(res.data.message);
    }
  } catch (err) {
    console.log(err);
    showToast(err?.response.data.error);
  }
}

function* editUser({ payload: { id, data, orgName, organizationId } }) {
  yield put({ type: SET_STATUS, payload: "pending" });

  let res = yield call(adminUsersApi.updateUser, id, {
    user: data
  });

  yield put({
    type: EDIT_USER_SUCCESS,
    payload: { id, data: res.data, orgName, organizationId }
  });
}

function* fetchEmails({ payload: { id } }) {
  // yield put({
  //   type: RESET_CURRENT_CATEGORY_INFO
  // });

  const { data } = yield call(adminUsersApi.getEmails, {
    params: { id }
  });

  yield put({
    type: FETCH_EMAILS_SUCCESS,
    payload: data
  });
}

function* removeUser(data) {
  try {
    let res = yield call(adminUsersApi.removeUser, {
      params: { id: data.payload.id, delete_completely: data.payload.isDeleted }
    });

    yield refetchUsers();

    if (res.status == 200) {
      showToast(res.data.message);
    }
  } catch (err) {
    console.log(err);
    showToast(err.response.data.error);
  }
}

function* activateUser(data) {
  try {
    let res = yield call(adminUsersApi.reactivate, { id: data.payload.id.toString() });

    yield refetchUsers();

    if (res.status == 200) {
      showToast(res.data.message);
    }
  } catch (err) {
    console.log(err);
    showToast(err.response.data.error);
  }
}
